import { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Logo from './Logo';
import { NAV_LINKS } from '../constants/content';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Header() {
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="shell site-header__inner">
        <Link to="/" className="brand" onClick={close}>
          <Logo />
        </Link>

        <button
          type="button"
          className="nav-toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`site-nav ${open ? 'is-open' : ''}`} aria-label="Primary">
          {NAV_LINKS.map((link) =>
            link.href.startsWith('#') ? (
              <a key={link.href} href={link.href} onClick={close}>
                {link.label}
              </a>
            ) : (
              <Link key={link.href} to={link.href} onClick={close}>
                {link.label}
              </Link>
            )
          )}
          <a href={SUPPORT_PHONE_TEL} className="site-nav__phone" onClick={close}>
            Call {SUPPORT_PHONE_LABEL}
          </a>
          <button
            type="button"
            className="btn btn--chat site-nav__chat"
            onClick={() => {
              close();
              openZohoChat();
            }}
          >
            Live Chat
          </button>
        </nav>

        <div className="header-actions">
          <a href={SUPPORT_PHONE_TEL} className="header-phone">
            <Icon name="phone" size={18} />
            {SUPPORT_PHONE_LABEL}
          </a>
          <button type="button" className="btn btn--chat header-chat" onClick={openZohoChat}>
            <Icon name="chat" size={18} />
            Live Chat
          </button>
        </div>
      </div>
    </header>
  );
}
